/**
 * Created by jv on 2019-09-09 (12:44).
 */
const Analytics = {};

((Analytics) =>
{
  Analytics.setPage = function(url)
  {
    if(__DEVELOPMENT__)
    {

    }
    else
    {
        // ga("set", "page", url);
        // ga("send", "pageview");
    }
  };
})(Analytics);

export default Analytics;



// WEBPACK FOOTER //
// ./app/js/misc/analytics.js